// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const TicketIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 56 56">
    <path
      fill="url(#ticket_svga)"
      fillRule="evenodd"
      d="M7.17 16.31h41.65l.44.05.42.13.37.2.32.27.27.32.2.38.13.41.05.44v6.15c0 .65-.52 1.17-1.17 1.17a3.65 3.65 0 0 0 0 7.3c.65 0 1.17.53 1.17 1.18v5.55l-.05.44-.12.41-.2.38-.28.32-.32.27-.37.2-.42.13-.44.05H7.17L6.73 42l-.42-.13-.37-.2-.33-.27-.27-.32-.2-.38-.13-.41-.04-.44V34.3c0-.65.52-1.17 1.16-1.17a3.66 3.66 0 0 0 0-7.3c-.64 0-1.16-.53-1.16-1.18v-6.15l.04-.44.13-.41.2-.38.27-.32.33-.27.37-.2.42-.13zm29.09 2.34H7.3v4.96a6 6 0 0 1 0 11.75v4.36h28.96v-2.01a1.17 1.17 0 0 1 2.33 0v2.01h10.1v-4.36a6 6 0 0 1 0-11.75v-4.96h-10.1v1.76a1.17 1.17 0 1 1-2.33 0zM16.57 30.3a1.17 1.17 0 0 1 0-2.34h14.59a1.17 1.17 0 0 1 0 2.34zm19.69-6.19a1.17 1.17 0 0 1 2.33 0v2.93a1.17 1.17 0 1 1-2.33 0zm-19.69 1.84a1.17 1.17 0 0 1 0-2.33h8.06a1.17 1.17 0 0 1 0 2.33zm0 8.8a1.17 1.17 0 0 1 0-2.33h14.59a1.17 1.17 0 0 1 0 2.34zm19.69-3.91a1.17 1.17 0 0 1 2.33 0v2.93a1.17 1.17 0 1 1-2.33 0z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="ticket_svga"
        x1={4.97}
        x2={28.05}
        y1={16.31}
        y2={55.56}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "Ticket",
);
export default TicketIcon;
